import { useSelector } from 'react-redux';
import { Redirect } from 'react-router';
import identity from 'lodash-es/identity';

const freeAccess = () => null;

const restrict = (Component) =>
  function (props) {
    const {
      route: { checkAccess = freeAccess },
    } = props;
    const state = useSelector(identity);
    const error = checkAccess(state, true);

    return error ? <Redirect to={error} /> : <Component {...props} />;
  };

export default restrict;
